function getImgixUrl(baseUrl, newParams) {
    if (!baseUrl) return baseUrl;
    let url = baseUrl;
    let query = '';
    const splitted = url.split('?');
    let params = {};
    [url] = splitted;
    if (splitted.length > 1) splitted[1].split('&').forEach((param)=>{
        const [key, value] = param.split('=');
        if (key && value) params[key] = value;
    });
    params = {
        ...params,
        ...newParams,
        fit: newParams?.fit || params.fit || 'crop'
    };
    if (Object.keys(params).length > 0) {
        Object.keys(params).forEach((key)=>{
            query = query.concat(`${key}=${params[key]}&`);
        });
        query = query.slice(0, query.length - 1);
    }
    if (query.length > 0) url = `${url}?${query}`;
    return url;
}
const src_getImgixUrl = getImgixUrl;
export default src_getImgixUrl;
